import { Component, Input, OnInit } from '@angular/core';
import { Segment } from '../../../model/segment';

@Component({
  selector: 'app-travel-box-wpp',
  templateUrl: './travel-box-wpp.component.html',
  styleUrls: ['./travel-box-wpp.component.css']
})
export class TravelBoxWppComponent implements OnInit {
  @Input() segments:Segment[]=[];
  private departure: string;
  private arrival: string;
  private dateDif: string;
  constructor() {
  }

  ngOnInit() {
  }
  public getDateTable(fechaStr: string): String {

    return this.getDate(true, fechaStr);

  }
  private getWeekday(n: number = -1, full: boolean = true, date: string): string {
    if (n == -1) {
      //let d:Date = new Date(this.date);
      let d: Date = this.mkDate(date);
      return this.getWeekday(d.getDay(), full, date);
    }
    if (!full) {
      switch (n) {
        case 0: return 'Dom';
        case 1: return 'Lun';
        case 2: return 'Mar';
        case 3: return 'Mié';
        case 4: return 'Jue';
        case 5: return 'Vie';
        case 6: return 'Sáb';
      }
    } else {
      switch (n) {
        case 0: return 'Domingo';
        case 1: return 'Lunes';
        case 2: return 'Martes';
        case 3: return 'Miércoles';
        case 4: return 'Jueves';
        case 5: return 'Viernes';
        case 6: return 'Sábado';
      }
    }


  }
  private getDate(with_weekday: boolean = true, date: string): string {
    //let d:Date = new Date(this.date);
    let d: Date = this.mkDate(date);
    var s: string = "";
    if (with_weekday) {
      s += this.getWeekday(d.getDay(), false, date) + " ";
    }
    s += d.getDate() + "/" + (d.getMonth() + 1) + "/" + d.getFullYear();
    return s;
  }
  private mkDate(s: string): Date {
    var mps: string[] = s.split(" ");
    let now: Date = new Date();
    if (mps.length == 1) {
      mps.push("00:00:01");
    }
    let dps: string[] = mps[0].split("-");
    let tps: string[] = mps[1].split(":");

    let year: number = dps.length >= 1 ? parseInt(dps[0]) : now.getFullYear();
    let month: number = dps.length >= 2 ? parseInt(dps[1]) - 1 : now.getMonth();
    let day: number = dps.length >= 3 ? parseInt(dps[2]) : now.getDate();

    let hour: number = tps.length >= 1 ? parseInt(tps[0]) : now.getHours();
    let minute: number = tps.length >= 2 ? parseInt(tps[1]) : now.getMinutes();
    let second: number = tps.length >= 3 ? parseInt(tps[2]) : now.getSeconds();

    let dd: Date = new Date(year, month, day, hour, minute, second);
    return dd;
  }
  public getDuration(date: string, departure: string, arrival: string): string {

    this.departure = departure;
    this.arrival = arrival;
    this.dateDif = date

    var dd = this.mkDate(this.getDepartureDateTime());
    var ad = this.mkDate(this.getArrivalDateTime());

    if (this.getArrivalDateTime() < this.getDepartureDateTime()) {
      dd = this.mkDate(this.getArrivalDateTime());
      ad = this.mkDate(this.getDepartureDateTime());
    };

    if (ad.getHours() != 0 && dd.getHours() != 0) {
      var dif: number = ad.getTime() - dd.getTime()

      var s: number = 1000;
      var m: number = s * 60;
      var h: number = m * 60;
      var hrs: number = Math.ceil(dif / h) - 1; dif = dif % h;
      var mins: number = Math.ceil(dif / m);

      var hrss: string = hrs < 10 ? '0' + hrs : '' + hrs;
      var minss: string = mins < 10 ? '0' + mins : '' + mins;

      return hrss + ":" + minss;
    }

    if (ad.getHours() == 0 || dd.getHours() == 0) {
      var dif: number = ad.getTime() - dd.getTime()

      var s: number = 1000;
      var m: number = s * 60;
      var h: number = m * 60;
      var hrs: number = Math.ceil(dif / h); dif = dif % h;
      var mins: number = Math.ceil(dif / m);
      hrs = 24 - hrs;
      mins = 60 - mins;
      var hrss: string = hrs < 10 ? '0' + hrs : '' + hrs;
      var minss: string = mins < 10 ? '0' + mins : '' + mins;

      return hrss + ":" + minss;
    }

  }
  private getDepartureDateTime(): string {
    return this.dateDif + " " + this.departure;
  }
  private getArrivalDateTime(): string {
    return this.dateDif + " " + this.arrival;
  }

}
